var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import { Card, CardContent, CircularProgress, Stack, Typography, } from "@mui/material";
import { useEffect, useRef } from "react";
import { FeedCard } from "./FeedCard";
export var Feed = function (_a) {
    var feed = _a.feed, hasNextPage = _a.hasNextPage, isFetchingNextPage = _a.isFetchingNextPage, fetchNextPage = _a.fetchNextPage;
    var loaderRef = useRef(null);
    useEffect(function () {
        if (!hasNextPage || isFetchingNextPage)
            return;
        var observer = new IntersectionObserver(function (_a) {
            var _b = __read(_a, 1), entry = _b[0];
            if (entry === null || entry === void 0 ? void 0 : entry.isIntersecting)
                fetchNextPage();
        });
        if (loaderRef.current)
            observer.observe(loaderRef.current);
        return function () { return observer.disconnect(); };
    }, [hasNextPage, isFetchingNextPage, fetchNextPage]);
    var allFeedItems = feed.pages.flatMap(function (page) { return page.results; });
    return (_jsxs(Stack, { spacing: 2, children: [allFeedItems.length === 0 ? (_jsx(Card, { sx: { p: 4, textAlign: "center" }, children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "h6", sx: { mb: 2, color: "text.secondary" }, children: "No Activity Yet" }), _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 2 }, children: "There's no recent soccer activity to show." }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: "Activity will appear here when teams play matches, organize tournaments, or complete transfers." })] }) })) : (allFeedItems.map(function (item, idx) { return renderFeedCard(item, idx); })), isFetchingNextPage && _jsx(CircularProgress, {}), hasNextPage && _jsx("div", { ref: loaderRef })] }));
};
var renderFeedCard = function (item, key) {
    var _a, _b;
    switch (item.activityType) {
        case "external_match": {
            var externalMatch = item.data;
            return (_jsx(FeedCard, { icon: _jsx(GroupsIcon, {}), iconColor: "#6A1B9A", title: "External Match", subtext: externalMatch.externalMatchResult
                    ? "".concat(externalMatch.team.name, " ").concat(externalMatch.externalMatchResult.teamScore, " | ").concat(externalMatch.externalMatchResult.opponentTeamScore, " ").concat(((_a = externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.opponentTeam) === null || _a === void 0 ? void 0 : _a.name) || "Opponent Team")
                    : "".concat(externalMatch.team.name, " v ").concat(((_b = externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.opponentTeam) === null || _b === void 0 ? void 0 : _b.name) || "Opponent Team"), timestamp: item.timestamp, to: "/external-matches/".concat(externalMatch.id) }, key));
        }
        case "intra_squad_match": {
            var intraSquadMatch = item.data;
            return (_jsx(FeedCard, { icon: _jsx(SportsSoccerIcon, {}), iconColor: "#D32F2F", title: "Intra-Squad Match", subtext: intraSquadMatch.intraSquadMatchResult
                    ? "".concat(intraSquadMatch.teamAName, " ").concat(intraSquadMatch.intraSquadMatchResult.teamAScore, " | ").concat(intraSquadMatch.intraSquadMatchResult.teamBScore, " ").concat(intraSquadMatch.teamBName)
                    : "".concat(intraSquadMatch.teamAName, " v ").concat(intraSquadMatch.teamBName), timestamp: item.timestamp, to: "/intra-squad-matches/".concat(intraSquadMatch.id) }, key));
        }
        case "intra_squad_tournament": {
            var intraSquadTournament = item.data;
            return (_jsx(FeedCard, { icon: _jsx(EmojiEventsIcon, {}), iconColor: "#1976D2", title: "Intra-Squad Tournament", subtext: intraSquadTournament.tournamentName || "", timestamp: item.timestamp, to: "/intra-squad-tournaments/".concat(intraSquadTournament.id) }, key));
        }
        case "transfer": {
            var transfer = item.data;
            return (_jsx(FeedCard, { icon: _jsx(PersonAddIcon, {}), iconColor: "#388E3C", title: "Player Transfer", subtext: "".concat(transfer.playerFirstName, " ").concat(transfer.playerLastName, " joined ").concat(transfer.teamName), timestamp: item.timestamp, to: "/players/".concat(transfer.player) }, key));
        }
        default:
            return null;
    }
};
